import { FilterKeyTypes } from "../../shared/types/FilterKeys.types";
import {
  DELIVERABLE_CREATE_KEY,
  COA_CREATE_KEY,
  TEMPLATE_CREATE_KEY,
  RULE_ENGINE_TEMPLATE_UPLOAD_KEY,
  RULE_ENGINE_TEMPLATE_EXPORT_KEY,
  DELIVERABLE_VIEW_KEY,
  TENANT_NEMENIC_KEY,
} from "../../shared/utils/SessionConstants";

export const setFilteredKeys = (filteredKeys:FilterKeyTypes) => {
  localStorage.setItem("FilterKey", JSON.stringify(filteredKeys));
};
export const getFilteredKeys = (): FilterKeyTypes => {
  const storedFilterKeys = localStorage.getItem("FilterKey");
  return storedFilterKeys ? JSON.parse(storedFilterKeys) : null;
};
export const getFeatureKeys = () => {
  return JSON.parse(localStorage.getItem("features") ?? "[]");
};

export const getTenantId = () => {
  return localStorage.getItem(TENANT_NEMENIC_KEY) as string;
};

export const getAuthToken = () => {
  return localStorage.getItem("token");
};
export const hasDeliverableCreatePermission = () => {
  return getFeatureKeys().includes(DELIVERABLE_CREATE_KEY);
};
export const hasCoaCreatePermission = () => {
  return getFeatureKeys().includes(COA_CREATE_KEY);
};

export const hasTemplateCreatePermission = () => {
  return getFeatureKeys().includes(TEMPLATE_CREATE_KEY);
};

export const hasImportTemplatePermission = () => {
  return getFeatureKeys().includes(RULE_ENGINE_TEMPLATE_UPLOAD_KEY);
};

export const hasExportTemplatePermission = () => {
  return getFeatureKeys().includes(RULE_ENGINE_TEMPLATE_EXPORT_KEY);
};

export const hasDeliverableViewPermission = () => {
  return getFeatureKeys().includes(DELIVERABLE_VIEW_KEY);
};
